export default () =>
    typeof WebAssembly !== "undefined" &&
    typeof WebAssembly.instantiate !== "undefined"
